const fadeDuration = 200;
const fadedOutKeyframe = { opacity: '0' };
const fadedInKeyframe = { opacity: '1' };
const fadeIn = (el) => el.animate([fadedOutKeyframe, fadedInKeyframe], { duration: fadeDuration });
const fadeOut = (el) => el.animate([fadedInKeyframe, fadedOutKeyframe], { duration: fadeDuration });

export { fadeIn as a, fadeOut as f };
